import SuperagentBase from '../shared/superagent-base';

export default class AgentLookupResource extends SuperagentBase {
    getAgents(token, query) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/primes/agentLookup/${query}`)
                .set('api-key', 'Bearer ' + token)
                .then(({ body }) => {
                    resolve(body);
                })
                .catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-lookup-resource.js